
    import '/opt/buildhome/repo/packages/x/docs/x-skill/skills.zh-CN.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"技能列表","toc":"menu","filename":"docs/x-skill/skills.zh-CN.md","lastUpdated":1773710526000,"order":3,"__autoDescription":true,"description":"Ant Design X 提供了以下核心技能，帮助您快速构建 AI 对话应用："};